import React, { Component } from "react";

import CmsDevicesTable from "./CmsDevicesTable";
import { withDevices } from "../../../shared/containers/containerDevices";

import Icon from "../../../shared/items/static/icon";
import Input from "../../../shared/items/contols/input";
import styles from "./cmsDevices.module.scss";
import { withServiceHistory } from "../../../shared/containers/contaynerServiceHistory";
import CmsHistory from "../CmsHisory/CmsHistory";
import CmsDevicePanel from "./CmsDevicePanel";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { withCurrentDevices } from "../../../shared/containers/containerCurrentDevice";
import { states } from "../../../reducers/queriesStates";
import Preloader from "../../../shared/items/static/preloader";
import CmsCreateDeviceTools from "./CmsCreateDeviceTools";

let timeOutId = null;

class CmsDevices extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: null,
      isOpenHistoryView: false,
      isOpenUnitActionPanel: false,
      isOpenCreatePanel: false,
      changeDeviceId: null,
      madalPageTitle: null,
      error: null,
      replaceIsOk: null,
      deleteSensorsOnDelete: true,
      historyFilter: {
        unitId: null,
        companyId: null,
        deviceId: null,
        action: 0,
      },
    };
  }

  componentDidMount() {
    const { onSelectDevice } = this.props;

    onSelectDevice();
  }

  componentDidUpdate(prevProps) {
    const { replaceDeviceDataState, errors } = this.props;

    if (replaceDeviceDataState === states.FAILURE && prevProps.replaceDeviceDataState === states.REQUEST) {
      this.setState({ error: errors });

      setTimeout(() => {
        this.setState({ error: null });
      }, 3000);
    }

    if (replaceDeviceDataState === states.READY && prevProps.replaceDeviceDataState === states.REQUEST) {
      this.setState({ replaceIsOk: "Замена устройства успешна" });

      setTimeout(() => {
        window.document.location.reload();
      }, 1500);
    }
  }

  onChangeSearchTerm(name, value) {
    this.setState({ searchTerm: value });
    clearTimeout(timeOutId);

    const { onGetDevices } = this.props;
    const { searchTerm } = this.state;

    const onSearchTerm = () => {
      onGetDevices(searchTerm);
    };

    timeOutId = setTimeout(onSearchTerm, 200);
  }

  onSearch() {
    const { onGetDevices } = this.props;
    const { searchTerm } = this.state;
    clearTimeout(timeOutId);
    onGetDevices(searchTerm);
  }

  onViewHistoryDevice(deviceId, imei, type) {
    const { onGetServiceHistory } = this.props;
    const { historyFilter } = this.state;
    historyFilter.deviceId = deviceId;

    onGetServiceHistory(historyFilter);
    this.setState({
      isOpenHistoryView: true,
      isOpenUnitActionPanel: false,
      changeDeviceId: null,
      madalPageTitle: `История обслуживания ${imei} ${type}`,
    });

    this.setState(historyFilter);
  }

  onViewHistoryUnit(unitId, title, registerNumber) {
    const { onGetServiceHistory } = this.props;

    const { historyFilter } = this.state;
    historyFilter.unitId = unitId;

    onGetServiceHistory({ unitId });
    this.setState({
      isOpenHistoryView: true,
      isOpenUnitActionPanel: false,
      changeDeviceId: null,
      madalPageTitle: `История обслуживания ${title} ${registerNumber}`,
    });
    this.setState(historyFilter);
  }

  onViewDevicePanel(deviceId = null) {
    if (deviceId === null) {
      const { searchTerm } = this.state;

      this.onChangeSearchTerm(null, searchTerm);
    }

    const { historyFilter } = this.state;
    historyFilter.deviceId = deviceId;

    this.setState({ changeDeviceId: deviceId, isOpenHistoryView: false, isOpenUnitActionPanel: false });
    this.setState(historyFilter);
  }

  onViewHistoryCompany(companyId, title) {
    const { onGetServiceHistory } = this.props;

    const { historyFilter } = this.state;
    historyFilter.companyId = companyId;

    onGetServiceHistory(historyFilter);
    this.setState({ isOpenHistoryView: true, isOpenUnitActionPanel: false, madalPageTitle: `История обслуживания ${title}` });
    this.setState(historyFilter);
  }

  onReplaceHancleClick() {
    const { selectedDevice, currentDevice, onReplaceDevice } = this.props;

    onReplaceDevice({ id: currentDevice.id, deviceReplaceId: selectedDevice.id });
  }

  onChangeFilter(filterAction) {
    const { onGetServiceHistory } = this.props;

    const { historyFilter } = this.state;
    historyFilter.action = filterAction;

    onGetServiceHistory(historyFilter);
    this.setState({ historyFilter });
  }

  onClickCreatepanelView(isOpenCreatePanel) {
    this.setState({ isOpenCreatePanel });
  }

  render() {
    const { isOpenHistoryView, madalPageTitle, changeDeviceId, error, replaceIsOk, isOpenCreatePanel } = this.state;
    const { isTransering = false, devicePanelEnable = false, selectedDevice, replaceDeviceDataState, createPanel = false } = this.props;

    return (
      <div className={styles.cmsDevicesContainer}>
        {isOpenHistoryView ? (
          <CmsHistory
            title={madalPageTitle}
            onClose={() => {
              this.setState({
                isOpenHistoryView: false,
                historyFilter: {
                  unitId: null,
                  companyId: null,
                  deviceId: null,
                  action: null,
                },
              });
            }}
            onChangeFilter={this.onChangeFilter.bind(this)}
          />
        ) : null}
        {changeDeviceId !== null && devicePanelEnable ? (
          <CmsDevicePanel onViewDevicePanel={this.onViewDevicePanel.bind(this)} deviceId={changeDeviceId} />
        ) : null}

        {createPanel ? <CmsCreateDeviceTools onClickCreatepanelView={this.onClickCreatepanelView.bind(this)} /> : null}

        <div className={styles.buttonsContainer}>
          {!isOpenCreatePanel ? (
            <div className={styles.searchDevices}>
              <Input name="searchTerm" type="text" handleChangeStore={this.onChangeSearchTerm.bind(this)} placeholder="Поиск" />
              <div
                className={styles.container_searchBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  this.onSearch();
                }}
              >
                <Icon name="search" />
              </div>
            </div>
          ) : null}

          {isTransering && selectedDevice !== null ? (
            <div className={styles.transferDeviceButton}>
              <div className={styles.replaceError}>{error}</div>
              <div className={styles.replaceIsOk}>{replaceIsOk}</div>
              {replaceDeviceDataState === states.REQUEST ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Preloader />
                </div>
              ) : (
                <div>
                  <div>dsf</div>
                  <ButtonPrimary handleClick={this.onReplaceHancleClick.bind(this)} title="Заменить" />
                </div>
              )}
            </div>
          ) : null}
        </div>

        <CmsDevicesTable
          onViewHistoryDevice={this.onViewHistoryDevice.bind(this)}
          onViewHistoryUnit={this.onViewHistoryUnit.bind(this)}
          onViewHistoryCompany={this.onViewHistoryCompany.bind(this)}
          onViewDevicePanel={this.onViewDevicePanel.bind(this)}
          isTransering={isTransering}
        />
      </div>
    );
  }
}

export default withCurrentDevices(withDevices(withServiceHistory(CmsDevices)));
